export enum ResizeTypeEnum {
  BOOK = 'BOOK',
  CHARACTER = 'CHARACTER',
}
